/**
 * Hero Carousel
 */

// Import extend function.
import Component from '../../js/core/component.js';
import Carousel from '../carousel/c-carousel.js';
import icon from '../icon/c-icon.js';
import getDataSettings from '../../js/utilities/get-data-settings/u-get-data-settings.js';
import breakpoint from '../../js/utilities/breakpoint/u-breakpoint.js';

class EventCarousel extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;

		this.carousel = new Carousel({
			debug: false,
			element: this.element,
			buttons: true,
			navigation: true,
			itemsPerSlide: 3,
			text: {
				prevButton: this._createButton('Previous slide', '/gui/images/icons/arrow-left.svg'),
				nextButton: this._createButton('Next slide', '/gui/images/icons/arrow-right.svg'),
			},
			hooks: {
				carouselHeight: (carousel, height) => {
					return height + parseFloat(window.getComputedStyle(carousel.element, null).getPropertyValue('padding-bottom'));
				}
			}
		});

		breakpoint('only screen and (min-width:992px)', {
			enter: () => {
				this.carousel.destroy();
				this.carousel.settings.itemsPerSlide = 3;
				this.carousel.settings.buttons = true;
				this.carousel.init();
			}
		});

		breakpoint('only screen and (min-width:768px) and (max-width:991px)', {
			enter: () => {
				this.carousel.destroy();
				this.carousel.settings.itemsPerSlide = 2;
				this.carousel.settings.buttons = true;
				this.carousel.init();
			}
		});

		breakpoint('only screen and (max-width:767px)', {
			enter: () => {
				this.carousel.destroy();
				this.carousel.settings.itemsPerSlide = 1;
				this.carousel.settings.buttons = false;
				this.carousel.init();
			}
		});
	}

	_createButton (text, iconUrl = false) {
		let buttonIcon = icon({
			icon: iconUrl,
			size: 's'
		});

		let content = document.createElement('span');
		content.appendChild(buttonIcon);

		let contentInner = document.createElement('span');
		contentInner.classList.add('t-visually-hidden');
		contentInner.appendChild(document.createTextNode(text));
		content.appendChild(contentInner);

		return content;
	}

}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-event-carousel').forEach(element => {
		let settings = getDataSettings(element, {
			debug: false,
			element: element
		});

		element.eventCarousel = new EventCarousel(settings);
	});
});

export default EventCarousel;


// WEBPACK FOOTER //
// ./components/event-carousel/c-event-carousel.js